import { createSelector } from 'reselect';
import { filter, pathEq, prop, path, applySpec, reduce } from 'ramda';

const localState = prop('practitioners');

export const getPractitionersEntry = createSelector(
  localState,
  path(['data', 'entry']),
);

export const getPractitionersLoading = createSelector(
  localState,
  prop('loading'),
);

export const getPractitionersShouldShowLoading = createSelector(
  [getPractitionersLoading, getPractitionersEntry],
  (loading, data) => loading && !data,
);

export const handlePractitionersBySite = reduce(
  (acc, participant) => ({
    ...acc,
    [`${path(['resource', 'id'], participant)}`]: applySpec({
      reference: item =>
        `${path(['resource', 'resourceType'], item)}/${path(['resource', 'id'], item)}`,
      identifier: item => ({
        value: `${path(['resource', 'qualification', '0', 'code', 'coding', '0', 'code'], item)}`,
      }),
      display: path(['resource', 'name', '0', 'text']),
    })(participant),
  }),
  {},
);

export const getPractitionersByRole = role =>
  createSelector(
    getPractitionersEntry,
    filter(pathEq(['resource', 'qualification', '0', 'code', 'coding', '0', 'code'], role)),
  );
